<template>
    <svg t="1657520210220" class="icon" viewBox="0 0 1536 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1408" width="200" height="200">
        <path
            d="M767.228803 0.004267A826.620556 826.620556 0 0 0 0 512.002133a831.996533 831.996533 0 0 0 1535.9936 0 832.081866 832.081866 0 0 0-768.764797-511.997866z m0 831.996533A319.998667 319.998667 0 1 1 1086.886138 512.002133a320.851996 320.851996 0 0 1-319.657335 319.998667zM958.972004 512.002133a191.828534 191.828534 0 1 1-191.743201-191.9992A192.425865 192.425865 0 0 1 958.972004 512.002133z m0 0"
            fill="#FFFFFF" p-id="1409"></path>
    </svg>
</template>
